<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 text-center">
                <div class="p-t-40">
                    <h3 class="" v-if="currentIntegrations.length ===0">There are no linked application yet.</h3>
                    <div class="card">
                        <div class="card-body" v-if="currentIntegrations.length > 0">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th class="border-0">App Name</th>
                                        <th class="border-0">App Key</th>
                                        <th class="border-0">Secret Key</th>
                                        <th class="border-0">Created On</th>
                                        <th class="border-0">Expires On</th>
                                        <th class="border-0">Status</th>
                                        <th class="border-0"> Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr :key="integrations.id" v-for="integrations of currentIntegrations">
                                        <td>{{integrations.app_name}}</td>
                                        <td>{{(integrations.app_key).slice(0, 8) +"....."+(integrations.app_key).slice(27)}}</td>
                                        <td>{{(integrations.secret_key).slice(0, 8) +"....."+(integrations.secret_key).slice(27)}}</td>
                                        <td>{{integrations.created_on | date}}</td>
                                        <td>{{integrations.expires_at | date}}</td>
                                        <td>
                                            <label class="label label-success">{{integrations.status}}</label>
                                        </td>

                                        <td v-if="integrations.status!=='DISABLED'">
                                            <button @click="disable(integrations.app_key)" class="btn btn-xs btn-danger waves-effect waves-light">DISABLE</button>
                                        </td>
                                        <td v-if="integrations.status==='DISABLED'">
                                            <button class="btn btn-xs btn-info waves-effect waves-light" disabled>NO ACTION</button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-4 text-center">
                                <button class="btn btn-lg waves-effect waves-light btn-success" data-target="#truvitoLoginModal" data-toggle="modal" data-whatever="@getbootstrap" id="truvito"><i
                                        class="fas fa-plus"></i>&nbsp;Integrate Truvito
                                </button>
                            </div>
                            <div class="col-4 text-center">
                                <button class="btn btn-lg waves-effect waves-light btn-success" data-toggle="modal" data-whatever="@getbootstrap" id="Google"><i
                                        class="fab fa-google-plus-g"></i>&nbsp;Integrate Gmail
                                </button>
                            </div>
                            <div class="col-4 text-center">
                                <button class="btn btn-lg waves-effect waves-light btn-success" data-toggle="modal" data-whatever="@getbootstrap" id="facebook"><i
                                        class="fab fa-facebook-f"></i>&nbsp;Integrate Facebook
                                </button>
                            </div>
                        </div>
                        <!--<div class="m-t-30 text-center">-->
                        <!--<img :src="tempImage" class="rounded-circle" v-if="tempImage" width="150" height="140"/>-->
                        <!--<img :src="imageSrc" class="rounded-circle" v-if="!tempImage && imageSrc" width="150" height="140"/>-->
                        <!--<img class="rounded-circle" src="../../../assets/images/logo/truvito-icon-lg.png" v-if="!tempImage  && !imageSrc" width="150" height="140"/>-->
                        <!--<h4 class="card-title m-t-10">TruVito</h4>-->

                        <!--</div>-->

                    </div>

                </div>
            </div>
        </div>
        <truvito-login-modal></truvito-login-modal>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import Multiselect from 'vue-multiselect';
    import TruvitoLoginModal from './modals/TruvitoLoginModal'

    export default {
        name: "invoices",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Multiselect, Paginate, TruvitoLoginModal},
        data() {
            return {
                currentIntegrations: []

            };
        },
        mounted() {
            this.checkIntegrations();
           // this.getAudits();
        },
        methods: {
            async searchCustomers(searchText) {

            },
            async checkIntegrations() {
                let reply                = await this.$http.get(`/integrations/`);
                this.currentIntegrations = reply.data;
                $('.btn').show();
                this.currentIntegrations.forEach((row) => {
                    this.hideButton(row.app_name, row.status);
                })
            },

            disable(appKey) {

                this.$http.delete('/integrations/', {data: {app_key: appKey}})
                .then(reply => {
                    this.checkIntegrations();
                })
                .catch(err => {
                    let data = err.response.data;
                    if(data.status === 403) {
                        this.$swal({
                            type: 'error',
                            title: 'Authentication Error',
                            text: 'Your API key is Blocked',
                            timer: 5000
                        });
                    } else {
                        this.$swal({
                            type: 'error',
                            title: 'Something Went Wrong',
                            timer: 5000
                        });
                    }
                })

            },
            hideButton(name, status) {
                if(status !== 'DISABLED') {
                    $('#' + name).hide();
                }

            }

        }
    }
</script>

<style scoped>
    h5.address {
        font-family: Source Code Pro, monospace;
        color: #4f5382;
        font-size: 16px;
    }
</style>